export default function getGradientForBarValue (chart, value, average, chartRatio) {
    const ctx = chart.ctx
    const chartArea = chart.chartArea

    const ratio = value / average

    const globalRatio = chartRatio

    const normalizedPosition = Math.min(ratio / globalRatio, 1)

    const gradient = ctx.createLinearGradient(
      chartArea.left,
      0,
      chartArea.right,
      0
    )

    if (ratio < 0.6) {
      const intensity = Math.max(0.4, normalizedPosition)
      gradient.addColorStop(0, `rgba(188, 22, 37, ${intensity})`)
      gradient.addColorStop(0.3, "#BC1625")
      gradient.addColorStop(1, "rgba(188, 22, 37, 0.6)")
    } else if (ratio < 1) {
      gradient.addColorStop(0, "#EAC90E")
      gradient.addColorStop(0.6, "#EAC90E")
      gradient.addColorStop(0.8, "#D68D00")
      gradient.addColorStop(1, "rgba(214, 141, 0, 0.7)")
    } else {
      const blueIntensity = 0.5 + normalizedPosition * 0.5

      gradient.addColorStop(0, `rgba(1, 64, 190, ${blueIntensity})`)
      gradient.addColorStop(0.5, "#0140BE")

      if (ratio > 1.5) {
        gradient.addColorStop(0.8, "#4285F4")
        gradient.addColorStop(0.9, "#0140BE")
      }

      gradient.addColorStop(1, "rgba(1, 64, 190, 0.7)")
    }

    return gradient
  }